import { Toaster as Sonner } from 'sonner';

import { useTheme } from '@/modules/common';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      position="top-center"
      richColors
      visibleToasts={5}
      {...props}
    />
  );
};

export { Toaster };
